import i18next from 'i18next';

// declarado p/ strict mode (era global implicito)
var data;

export const deletarCurriculo = {
    swalDeletar: function () {
        swal({
            title: i18next.t('deletarCurriculoTitulo'),
            text: i18next.t('deletarCurriculoTexto'),
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: i18next.t('deletarCurriculoExcluir'),
            cancelButtonText: i18next.t('deletarCurriculoCancelar'),
            closeOnConfirm: false
        }, function (isConfirm) {
            if (isConfirm) {
                $.ajax({
                    type: "GET",
                    url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/RemoveArquivoCurriculo',
                    cache: false,
                    success: function (data) {
                        if (data.sucesso) {
                            swal("Removido", data.mensagem, "success");
                            $("#row-baixar-curriculo").hide();
                            $("#row-anexar-curriculo").show();
                        }
                        else {
                            swal("", data.erro, "error");
                            $("#row-baixar-curriculo").show();
                            $("#row-anexar-curriculo").hide();
                        }

                    },
                    error: function () {
                        swal("", data.erro, "error");
                    }
                });

            }
        });
    },

    init: function () {
        $('#btn-deletar-curriculo').on('click', function (e) {
            deletarCurriculo.swalDeletar();
            e.preventDefault();
        });
    }
}

